module.exports = __webpack_public_path__ + "static/media/website_home.39b02158.mp4";